module.exports = __webpack_public_path__ + "img/panelist-dp.73265da5.svg";